// extracted by mini-css-extract-plugin
export default {"input":"text_input_input__x8wrM"};